import {figmaColors} from './colors';

export const styles = {
  global: {
    body: {
      background: figmaColors['grey-300'],
    }
  }
}